import script from "./AdminSellersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSellersPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminSellersPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__